module.exports = __webpack_public_path__ + "naghmeh-social-icon--spotify--dark.svg?21c8064b0f192d36e6447acf169df07b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-icons-edited/naghmeh-social-icon--spotify--dark.svg
// module id = 210
// module chunks = 0